<div class="onset-indicator d-flex justify-content-between" style="align-items: center">
  <div>
    <button *ngFor="let indicator of indicators; let i = index;" class="btn button-indicator"
      [ngClass]="{'done': i < currentExcerciseNumber-1 || testDone, 'current': i == currentExcerciseNumber-1 }">{{indicator}}</button>
  </div>
  <div *ngIf="displayLogo">
    <img style="max-width: 100px;" [src]="cTestLogo">
  </div>
</div>